import Styled from 'styled-components';

const ReviewsContainer = Styled.div`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  > div {
    margin-bottom: 20px;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

const LoadingContainer = Styled(ReviewsContainer)`
  > div {
    > div {
      position: relative;
    }
  }
`;
const NoCommentsContainer = Styled.div`
  padding: 56px 0 104px 0;
  
`;

export default ReviewsContainer;
export { ReviewsContainer, LoadingContainer, NoCommentsContainer };
